/**
 * The confirmation surfaces App.vue mounts, and the names that address them.
 *
 * PrimeVue matches a `confirm.require({ group })` to a mounted ConfirmPopup /
 * ConfirmDialog on strict equality, so the group is not decoration: it chooses
 * WHICH surface appears, and a name that matches neither reaches nothing at
 * all — no popup, no `accept`, no error. That is how every confirmation in
 * this app silently did nothing until it was noticed.
 *
 * `as const` is what makes a typo'd group a type error rather than a
 * confirmation that silently never opens.
 */
export const CONFIRM_GROUP = {
    /** Anchored to the element that triggered it; pass a `target`. */
    popup: "popup",
    /** Centred modal, for surfaces with no useful anchor. */
    dialog: "dialog",
} as const;
